export const numberFormatter = (number = 0): string => {
  return Math.round(number).toLocaleString();
};

export function getCurrentCustomerCount({
  startValue = 498548,
  dailyIncrement = 208,
  startDate = '2025-11-25',
  isFormatted = true
} = {}) {
  const oneDay = 1000 * 60 * 60 * 24;
  const now = new Date();
  const start = new Date(startDate);
  const daysPassed = Math.floor((now.getTime() - start.getTime()) / oneDay);
  const clients = startValue + (dailyIncrement * daysPassed);

  return isFormatted ? numberFormatter(clients) : clients;
}

export const formatNumberToShortForm = (num: number): string => {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1_000) {
    return Math.round(num / 1_000) + 'K';
  }
  return num.toString();
};
